import React from 'react';
import { TermsOfService as TOS, Header, Footer } from '../components/components'

const TermsOfService = () => {
    return (
        <>
            <Header />
            <TOS />
            <Footer />
        </>
    );
};

export default TermsOfService;